import React from 'react'

function Elimu1() {
  return (
    <div>


<b>Guaranteed cash bonuses</b><br></br>
Five annual bonuses amounting of 20% of the sum assured are paid in cash after the child attains 13 years.<br></br>
<b>Maturity benefit</b><br></br>
The policy will pay 100% of the sum assured on maturity before the insured 19th birthday regardless of any previous benefit payments e.g. death or bonuses as outlined above.
<br></br><b>Death benefit</b><br></br>
In the event of untimely death of the policy owner, Britam will pay the death rider, waive future premiums and provide full benefits at maturity. All future bonuses will be paid when they fall due.
In the event of untimely death of the child, Britam will pay the sum assured or refund the premiums, whichever is higher.
<br></br><b>Lien option (Non-medical requirement)</b><br></br>
This option provides for an increasing death benefit. Death benefit will be a percentage of the sum assured at inception increasing to 100% of the sum assured from the fifth year. The increasing death benefit is cheaper and underwriting requirements are reduced.
<br></br><b>Tax Relief</b><br></br>
An insurance tax relief amounting to 15% of the premiums paid (subject to a maximum of Kshs. 5,000 per month) is available. The full amount payable at maturity of the policy is tax free.





    </div>
  )
}

export default Elimu1